













































import { Component, Watch } from "vue-property-decorator";
import WindowVue from "@/app/core/window/WindowVue";
import { Mixins } from "vue-mixin-decorator";
import VueEvent from "@/app/core/decorator/VueEvent";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import BcdiceManager from "@/app/core/api/bcdice/BcdiceManager";
import { BcdiceVersionInfo } from "@/@types/bcdice";
import LanguageManager from "@/LanguageManager";
import BaseInput from "@/app/core/component/BaseInput.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";

@Component({
  components: {
    CtrlButton,
    BaseInput
  }
})
export default class BcdiceApiServerSettingWindow extends Mixins<
  WindowVue<string, string>
>(WindowVue) {
  private url: string = "";
  private testMessage: string = "";
  private testStatus: string = "";
  private apiVersion: string = "";
  private bcdiceVersion: string = "";

  @LifeCycle
  public async mounted() {
    await this.init();
    this.url = this.windowInfo.args!;
  }

  @Watch("currentDiceBotSystem")
  private onChangeCurrentDiceBotSystem(system: string) {
    window.console.log(system);
  }

  @VueEvent
  private async test() {
    window.console.log("test");
    this.testStatus = "testing";
    try {
      const info: BcdiceVersionInfo = await BcdiceManager.getBcdiceVersionInfo(
        this.url
      );
      this.apiVersion = info.api;
      this.bcdiceVersion = info.bcdice;
      this.testStatus = "success";
    } catch (err) {
      this.testMessage = LanguageManager.instance.getText(
        `${this.windowInfo.key}.error-messages.connect-error`
      );
      this.testStatus = "error";
    }
  }

  @VueEvent
  private async commit() {
    await this.finally(this.url);
  }

  @VueEvent
  private async rollback() {
    await this.finally();
  }
}
